import React, { useState } from 'react';

import WithStatelessTooltip from '@r1-frontend/ui-react/experimental/tooltip/WithStatelessTooltip';

import { IStatefulTooltipProps } from './types';

const WithStatefulTooltip = ({
    children,
    content,

    position,
    withArrow,

    background,
    gap,
    arrowIndent,
    radius,
}: IStatefulTooltipProps) => {
    const [isShown, setIsShown] = useState(false);

    return (
        <WithStatelessTooltip
            content={content}
            position={position}
            isShown={isShown}
            background={background}
            gap={gap}
            arrowIndent={arrowIndent}
            withArrow={withArrow}
            radius={radius}
        >
            <div
                onMouseEnter={() => setIsShown(true)}
                onMouseLeave={() => setIsShown(false)}
            >
                {children}
            </div>
        </WithStatelessTooltip>
    );
};

export default WithStatefulTooltip;
